import clsx from "clsx";

import Days from "./MonthView/Days";
import Weekdays from "./MonthView/Weekdays";
import WeekNumbers from "./MonthView/WeekNumbers";

import { CALENDAR_TYPE_LOCALES, CALENDAR_TYPES } from "./shared/const";

function getCalendarTypeFromLocale(locale) {
  if (locale) {
    for (const [calendarType, locales] of Object.entries(
      CALENDAR_TYPE_LOCALES
    )) {
      if (locales.includes(locale)) {
        return calendarType;
      }
    }
  }

  return CALENDAR_TYPES.ISO_8601;
}

export default function MonthView(props) {
  const { activeStartDate, locale, onMouseLeave, showFixedNumberOfWeeks } =
    props;
  const {
    calendarType = getCalendarTypeFromLocale(locale),
    formatShortWeekday,
    formatWeekday,
    onClickWeekNumber,
    showWeekNumbers,
    ...childProps
  } = props;

  function renderWeekdays() {
    return (
      <Weekdays
        calendarType={calendarType}
        formatShortWeekday={formatShortWeekday}
        formatWeekday={formatWeekday}
        locale={locale}
        onMouseLeave={onMouseLeave}
      />
    );
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return (
      <WeekNumbers
        activeStartDate={activeStartDate}
        calendarType={calendarType}
        onClickWeekNumber={onClickWeekNumber}
        onMouseLeave={onMouseLeave}
        showFixedNumberOfWeeks={showFixedNumberOfWeeks}
      />
    );
  }

  function renderDays() {
    return <Days calendarType={calendarType} {...childProps} />;
  }

  const className = "react-calendar__month-view";

  return (
    <div
      className={clsx(
        className,
        showWeekNumbers ? `${className}--weekNumbers` : ""
      )}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        {renderWeekNumbers()}
        <div
          style={{
            flexGrow: 1,
            width: "100%",
          }}
        >
          {renderWeekdays()}
          {renderDays()}
        </div>
      </div>
    </div>
  );
}
